export default {
  state: {
    mainHeaderData: {
      headerText: ''
    },
    yToastMessage: {
      type: 'success',
      value: false,
      message: ''
    }
  }
}
